class AnalyticsService {
    track = (category = '', action = '', label = '', value = '') => {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'DNSEvent',
                eventCategory: category,
                eventAction: action,
                eventLabel: label,
                eventValue: value,
            });
        }
    };
}

export default new AnalyticsService();
